// TODO: Move to a more suitable package and merge with the similar functions defined in the various parts of the codebase.
/**
 * Generates a workspace ARI for Confluence.
 * Format: ari:cloud:confluence:{cloudId}:workspace/{activationId}
 */
export const getWorkspaceARI = ({
	cloudId,
	activationId,
}: {
	cloudId: string;
	activationId: string;
}) => {
	return `ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
};

